import swal from "sweetalert";
import Swal from 'sweetalert2';
export class SAlertComponent {
  static _WindowSpiner: any;

  /**
   * @author Jose Wilson Mulato
   * @description construye la alerta con su descripcion
   * @param title
   * @param text
   * @param icon
   */
  private static async Alert(title: string = null, text: string, icon) {
    return (swal || window["swal"])({
      title: title,
      html: text,
      icon: icon,
      backdrop: false,
      allowEscapeKey: false,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#019a01'
    });
  }

  /**
   * @author Jose Wilson Mulato
   * @description muestra una alerta de confirmacion
   * @param text
   * @param title
   */
  public static AlertOk(
    text: string = "Proceso realizado con éxito.",
    title: string = null
  ) {
    this.Alert(text, title, "success");
  }
  /**
   * @author Jose Wilson Mulato
   * @description muestra una alerta de informacion
   * @param text
   * @param title
   */
  public static async AlertInfo(text: string, title: string = null) {
    this.Alert(text, title, "info");
  }

  /**
   * @author Jose Wilson Mulato
   * @description muestra una alerta de alvertencia
   * @param text
   * @param title
   */
  public static async AlertWarning(text: string, title: string = null) {
    return this.Alert(text, title, "warning");
  }


  /**
   * @author Jose Wilson Mulato
   * @description muesta una alerta de salida
   * @param text
   * @param title
   */
  public static async AlertCamposObligatorios(text: string) {
    return Swal.fire({
      title: "",
      icon: "warning",
      html: text
    });
  }

  /**
   * @author Jose Wilson Mulato
   * @description muesta una alerta de salida
   * @param text
   * @param title
   */
  public static async AlertExit(text: string, title: string = null) {
    return (swal || window["swal"])({
      title: title,
      text: text,
      icon: "success",
      closeOnClickOutside: false,
      closeOnEsc: false
    });
  }

  /**
   * @author Jose Wilson Mulato
   * @description muesta una alerta de salida
   * @param text
   * @param title
   */
  public static async AlertNoAsoc(text: string, title: string = null) {
    return (swal || window["swal"])({
      title: title ? title : text,
      text: title ? text : null,
      icon: "warning",
      closeOnClickOutside: false,
      closeOnEsc: false
    });
  }

  /**
   * @author Jose Wilson Mulato
   * @description muestra una alerta con icono error y su texto
   * @param text
   * @param title
   */
  public static AlertError(
    text: string = "Error en el proceso.",
    title: string = null
  ) {
    return Swal.fire({
      title: "",
      icon: "error",
      html: text,
      width: 480,
      backdrop: false,
      allowEscapeKey: false,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#019a01'
    });
  }


  public static AlertErrorSinIcon(
    text: string = "Error en el proceso.",
    title: string = null
  ) {
    this.Alert(text, title, "");
  }

  /**
   * @author Jose Wilson Mulato
   * @description muesta el spinner global
   */
  public static ShowSpinner() {
    let spinner = document.createElement("i");
    spinner.className = "fas fa-spinner fa-spin";
    this._WindowSpiner = this._WindowSpiner || (swal || window["swal"]);
    this._WindowSpiner({
      content: spinner,
      closeOnEsc: false,
      className: "window-spiner"
    });
  }

  /**
   * @author Jose Wilson Mulato
   * @description Cierra el spiner global
   */
  public static CloseSpinner() {
    this._WindowSpiner.close();
  }

  /**
   * @author Jose Wilson Mulato
   * @description ventana emergente que solicita confirmacion con respecto al texto
   * @param text
   * @param danger
   * @param title
   */
  public static Confirm(
    text: string,
    danger: boolean = false,
    title: string = "Confirmación?"
  ): Promise<boolean> {
    return new Promise(res => {
      (swal || window["swal"])({
        title: title,
        text: text,
        icon: "success",
        buttons: ["OK", "Aceptar"],
        dangerMode: danger
      }).then(ok => {
        if (ok) {
          res(true);
        } else {
          res(false);
        }
      });
    });
  }

  /**
   * @author Cesar Augusto Millan
   * @description ventana emergente que solicita confirmacion con respecto al texto
   * @param text
   * @param danger
   * @param title
   */
  public static Confirm2(
    text: string,
    danger: boolean = false,
    title: string = "Confirmación",
    buttons: any = ["Cancelar", "Aceptar"]
  ): Promise<boolean> {
    return new Promise(res => {
      (swal || window["swal"])({
        title: title,
        text: text,
        icon: "warning",
        buttons: buttons,
        dangerMode: danger,
        cancelButtonColor: '#019a01'
      }).then(ok => {
        if (ok) {
          res(true);
        } else {
          res(false);
        }
      });
    });
  }

  public static ConfirmHTML(
    text: string
  ): Promise<boolean> {
    return new Promise(res => {
      Swal.fire({
        title: 'Confirmar',
        html: text,
        icon: 'warning',
        showCancelButton: true,
        allowEscapeKey: false,
        confirmButtonColor: '#019a01',
        cancelButtonColor: '#019a01',
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          res(true);
        }
      })
    });
  }


  // public static async InfoDonacion(text: string, title: string = null) {
  //   return (swal || window["swal"])({
  //     title: title,
  //     text: text,
  //     icon: "info",
  //     closeOnClickOutside: false,
  //     closeOnEsc: false
  //   });
  // }


  public static async InfoDonacionExists(text: string) {
    return Swal.fire({
      title: "",
      icon: "info",
      html: text,
      width: 480,
      allowEscapeKey: false,
      confirmButtonText: '<u>DONAR CON PINOS</u>',
      confirmButtonColor: '#019a01'
    });
  }


  public static async confirmar(text: string) {
    return Swal.fire({
      title: "",
      icon: "warning",
      html: text,
      width: 480,
      allowEscapeKey: false,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#019a01',
      showCloseButton: true
    });
  }


  public static async showMensajeErrorRedencion(text: string) {
    return Swal.fire({
      title: "",
      icon: "warning",
      html: text,
      width: 480,
      allowEscapeKey: false,
      confirmButtonText: 'OK',
      confirmButtonColor: '#019a01'
    });
  }



  public static async showExitoDonacionAmbos(text: string) {
    return Swal.fire({
      title: "",
      icon: "success",
      html: text,
      width: 600,
      backdrop: false,
      allowEscapeKey: false,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#019a01'
    });
  }

  public static async showWarning(text: string) {
    return Swal.fire({
      title: "",
      icon: "warning",
      html: text,
      width: 480,
      backdrop: false,
      allowEscapeKey: false,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#019a01'
    });
  }

  public static async showExito(text: string) {
    return Swal.fire({
      title: "",
      icon: "success",
      html: text,
      width: 480,
      backdrop: false,
      allowEscapeKey: false,
      confirmButtonText: 'Aceptar',
      confirmButtonColor: '#019a01'
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/s-alert/s-alert.component.ts